import Typed from 'typed.js';
import {useEffect,useRef} from "react";

const Animatedtype = () => {



    const el =useRef(null);

    useEffect(() => {
        const typed = new Typed(el.current, {
            strings: ['کارت بازرگانی و ثبت شرکت',
                'صادرات' ,
                'واردات',
                  'اظهرانامه',
                  'ثبت سفارش',
                  'رفع تعهد ',
                ' گمرکی و ترخیص'],

            typeSpeed: 120,
            backSpeed: 0,
            fadeOut: true,
            loop: true
        });

        return () => {

            typed.destroy();
        };
    }, []);


    return (
        <>

            <span className='has-text-white kook is-size-2' ref={el} />



        </>

    )
}
export default Animatedtype;